import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { PagedResult } from '@/api/client';
import type { CustomerHistory } from '@/api/customers';
import type { Customer } from '@/api/types';

export function useCustomers(search: string, page = 1, limit = 30) {
  return useQuery({
    queryKey: ['customers', { search, page, limit }],
    queryFn: () => api.get<PagedResult<Customer>>('/api/customers', { search: search || undefined, page, limit }),
  });
}

export function useCustomerHistory(phone: string | null) {
  return useQuery({
    queryKey: ['customers', 'history', phone],
    queryFn: () => api.get<CustomerHistory>(`/api/customers/${encodeURIComponent(phone!)}/history`),
    enabled: phone !== null,
  });
}
